import React , {Component} from 'react'; 
import '../assets/scss/style.css';
 
class About extends Component {
 
    render(){
       
        return( 
            <article >
                <p> Programming:<a href="https://t.me/ktsyr1"> ktsyr1 </a> </p>
              
                 <main>
                    <h1>سجل التغيرات</h1>  
                    <div className='sh b-r'>
                        <p > beta 0.1.3 (  2019/10/5) </p> 
                        <p>تم حذف بعض المعلومات من صفحة post</p>
                    </div><br/>
                    <div className='sh b-r'>
                        <p > beta 0.1.2 (  2019/9/30) </p> 
                        <p>تم تصميمها ب  react </p>
                        <p>يدعم pwa</p>
                        <p>تم تسريع الموقع</p>
                        <p>يدعم بعض وضائف offline</p>
                    </div>
                     
                </main>
            </article>
        )
    }
}
 
export default About